// extracted by mini-css-extract-plugin
export default {"modalActions":"header-edit-modal_modalActions__BBXrQ"};